'use client';

import { c as _c } from "react/compiler-runtime";
import avatarIcon from '@public/images/avatar.svg';
import searchIcon from '@public/images/searchWhite.svg';
import Image from 'next/image';
import Link from 'next/link';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNavV6 } from '@src/components/TopNavV6/TopNavV6Context';
import type { TopNavV6Props } from '@src/components/TopNavV6/TopNavV6Props';
import { useSession } from '@src/hooks/useSession';
import cartIcon from '../assets/mobile-cart-icon.svg';
import hamburgerIcon from '../assets/mobile-hamburger-icon.svg';
export const TopNavV6MobileBar = props => {
  const $ = _c(45);
  const {
    logo,
    cartHref: t0,
    showSearch,
    onCartClick,
    onAccountClick,
    onSearchClick,
    mobileHomeButtonText: t1
  } = props;
  const cartHref = t0 === undefined ? "#cart" : t0;
  const mobileHomeButtonText = t1 === undefined ? "Home" : t1;
  const {
    setIsMobileMenuOpen,
    setAccountExpanded,
    setSearchOpen
  } = useTopNavV6();
  const {
    user,
    getLoginHref
  } = useSession();
  let t2;
  if ($[0] !== getLoginHref || $[1] !== onAccountClick || $[2] !== setAccountExpanded || $[3] !== user) {
    t2 = () => {
      if (!user) {
        window.location.href = getLoginHref();
        return;
      }
      if (onAccountClick) {
        onAccountClick();
        return;
      }
      setAccountExpanded(true);
    };
    $[0] = getLoginHref;
    $[1] = onAccountClick;
    $[2] = setAccountExpanded;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleAccountClick = t2;
  let t3;
  if ($[5] !== onSearchClick || $[6] !== setSearchOpen) {
    t3 = () => {
      setSearchOpen(true);
      onSearchClick?.();
    };
    $[5] = onSearchClick;
    $[6] = setSearchOpen;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleSearchClick = t3;
  let t4;
  if ($[8] !== logo) {
    t4 = logo?.src && <LocalizedLink href={logo.href ?? "/"} className="flex shrink-0 items-center"><Image className="h-6.25 w-19" src={logo.src} width={300} height={150} alt={logo.altText ?? "Logo"} /></LocalizedLink>;
    $[8] = logo;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <div className="relative flex h-11.75 w-full items-center justify-center border-b border-bodi-gray-dark bg-bodi-black-text" data-name="Mobile - Top Bar">{t4}</div>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== setIsMobileMenuOpen) {
    t6 = () => setIsMobileMenuOpen(true);
    $[12] = setIsMobileMenuOpen;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Image src={hamburgerIcon} width={24} height={24} alt="Menu" />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6) {
    t8 = <button data-testid="topNavMobileMenu" className="flex size-6 appearance-none items-center justify-center" onClick={t6}>{t7}</button>;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== setIsMobileMenuOpen) {
    t9 = () => setIsMobileMenuOpen(true);
    $[17] = setIsMobileMenuOpen;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== mobileHomeButtonText || $[20] !== t9) {
    t10 = <div className="flex h-full items-center border-l border-bodi-gray-medium py-0 pr-1 pl-2"><button className="text-body-md leading-4.5 font-semibold text-bodi-gray-butters uppercase" data-name="Home Button" onClick={t9}>{mobileHomeButtonText}</button></div>;
    $[19] = mobileHomeButtonText;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <div className="flex items-center gap-1">{t8}{t10}</div>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== handleSearchClick || $[26] !== showSearch) {
    t12 = showSearch && <button aria-label="Search" onClick={handleSearchClick} className="flex h-11 w-7 items-center justify-center py-4"><Image src={searchIcon} width={24} height={24} alt="Search" /></button>;
    $[25] = handleSearchClick;
    $[26] = showSearch;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Image src={cartIcon} width={24} height={24} alt="Shopping cart" className="h-6 w-6 object-cover" />;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== cartHref || $[30] !== onCartClick) {
    t14 = <div className="flex h-11 w-7 items-center justify-center py-4"><Link className="relative" data-testid="cartBtn" href={cartHref} onClick={onCartClick} scroll={false}>{t13}</Link></div>;
    $[29] = cartHref;
    $[30] = onCartClick;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Image src={avatarIcon} width={22} height={22} alt="Account icon" />;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== handleAccountClick) {
    t16 = <div className="flex h-11 items-center justify-end py-4"><button onClick={handleAccountClick} data-testid="accountBtn" className="flex h-[22px] w-6 items-center justify-center">{t15}</button></div>;
    $[33] = handleAccountClick;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t12 || $[36] !== t14 || $[37] !== t16) {
    t17 = <div className="flex items-center gap-3">{t12}{t14}{t16}</div>;
    $[35] = t12;
    $[36] = t14;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t11 || $[40] !== t17) {
    t18 = <div className="relative flex h-12 w-full items-center justify-between border-b border-bodi-gray-dark bg-bodi-black-text px-4" data-name="Mobile - Bottom Bar">{t11}{t17}</div>;
    $[39] = t11;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t18 || $[43] !== t5) {
    t19 = <>{t5}{t18}</>;
    $[42] = t18;
    $[43] = t5;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
};